import React from 'react';
import LegalLayout from './LegalLayout';

const TermsAndConditions = () => {
  return (
    <LegalLayout>
      <div className="container-standard px-4 max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          <div className="flex justify-center items-center mb-6">
            <a href="/" className="text-primary-accent font-bold hover:underline text-lg">
                 ← Volver al Inicio
              </a>
            </div>
           <div className="text-center mb-4">
            <h1 className="text-display font-bold text-primary-dark">Términos y Condiciones</h1>
          </div>
          <p className="text-center text-gray-600 mb-8">Última actualización: Febrero 2026</p>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">1. Aceptación de Términos</h2>
            <p className="mb-4">
              Al acceder y utilizar este sitio web, usted acepta cumplir con estos Términos y Condiciones en su totalidad. Si no está de acuerdo con estos términos, no debe utilizar este sitio web.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">2. Propiedad Intelectual</h2>
            <p className="mb-4">
              Todo el contenido de este sitio web, incluyendo pero no limitado a textos, gráficos, logotipos, íconos, imágenes, archivos de audio y software, es propiedad de DavidCorp S.R.L. o sus licenciantes y está protegido por las leyes peruanas e internacionales de derechos de autor y propiedad intelectual.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">3. Uso Aceptable</h2>
            <p className="mb-4">
              Usted acepta utilizar este sitio web únicamente para fines legales y de acuerdo con estos Términos y Condiciones. Queda prohibido:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Usar el sitio para cualquier propósito ilegal o no autorizado</li>
              <li>Intentar introducir virus u otros códigos dañinos</li>
              <li>Interferir o interrumpir el funcionamiento del sitio web</li>
              <li>Recopilar datos sobre otros usuarios sin su consentimiento</li>
              <li>Utilizar el sitio de manera que sobrecargue la infraestructura</li>
            </ul>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">4. Limitación de Responsabilidad</h2>
            <p className="mb-4">
              DavidCorp S.R.L. no será responsable de ningún daño indirecto, incidental, especial o consecuente que surja del uso o la imposibilidad de uso de este sitio web, incluso si se ha advertido de la posibilidad de tales daños.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">5. Garantías</h2>
            <p className="mb-4">
              El contenido de este sitio web se proporciona "tal cual". DavidCorp S.R.L. no ofrece garantías sobre la exactitud, integridad o idoneidad del contenido para un propósito particular. No garantizamos que el sitio web esté disponible en todo momento o libre de errores.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">6. Modificaciones de los Servicios</h2>
            <p className="mb-4">
              DavidCorp S.R.L. se reserva el derecho de modificar, suspender o interrumpir cualquier aspecto del sitio web en cualquier momento, con o sin previo aviso. También podemos modificar estos Términos y Condiciones en cualquier momento.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">7. Ley Aplicable</h2>
            <p className="mb-4">
              Estos Términos y Condiciones se regirán e interpretarán de acuerdo con las leyes de la República del Perú. Cualquier disputa relacionada con estos términos estará sujeta a la jurisdicción exclusiva de los tribunales del Perú.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">8. Políticas de Privacidad</h2>
            <p className="mb-4">
              El uso de este sitio web también está sujeto a nuestra Política de Privacidad, que describe cómo recopilamos, usamos y protegemos su información personal. Al utilizar este sitio, usted acepta las prácticas descritas en nuestra Política de Privacidad.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">9. Enlaces a Terceros</h2>
            <p className="mb-4">
              Este sitio web puede contener enlaces a sitios web de terceros. No tenemos control sobre el contenido, las políticas de privacidad o las prácticas de estos sitios externos y no asumimos ninguna responsabilidad por ellos.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">10. Indemnización</h2>
            <p className="mb-4">
              Usted acepta indemnizar y mantener indemne a DavidCorp S.R.L., sus directivos, empleados y agentes de cualquier reclamo o demanda, incluidos los honorarios razonables de abogados, presentados por terceros debido a su uso del sitio web o violación de estos Términos y Condiciones.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">11. Cambios en los Términos</h2>
            <p className="mb-4">
              Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación en este sitio. Su uso continuado del sitio después de dichos cambios constituye aceptación de los términos revisados.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">12. Contacto</h2>
            <p className="mb-4">
              Si tiene alguna pregunta sobre estos Términos y condiciones, contáctenos en:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg mb-4">
              <p className="font-medium">DAVID CORPORATION S.R.L. - DAVIDCORP S.R.L.</p>
              <p>RUC: 20602434011</p>
              <p>491 Jr. Sta Cruz de Pachacutec, Los Olivos, Lima, Perú</p>
              <p>Email: <a href="mailto:info@davidcorp-srl.com" className="text-primary-accent hover:underline">info@davidcorp-srl.com</a></p>
              <p>Teléfono: <a href="tel:+51936776570" className="text-primary-accent hover:underline">+51 936776570</a></p>
            </div>
          </div>
        </div>
      </div>
    </LegalLayout>
  );
};

export default TermsAndConditions;